import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const PageNotFound = () => {
    const { t } = useTranslation();
    return (
        <StyledWrapper>
            <h1>{t("Page not found header")}</h1>
            <Link to="/">{t("Back home")}</Link>
        </StyledWrapper>
    );
};

export default PageNotFound;

const StyledWrapper = styled.div`
    width: 100%;
    display: grid;
    justify-items: center;
    align-items: center;
`;
